import React from 'react'

import PropTypes from 'prop-types'

import './card.css'

const Card = ({
  description = 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium',
  rootClassName = '',
  icon = '/Icons/group%201316-200w.png',
  iconAlt = 'image',
  header = 'Sima Mosbacher',
}) => {
  return (
    <section className={`card-card ${rootClassName} `}>
      <div className="card-icon1">
        <img alt={iconAlt} src={icon} className="card-icon2" />
      </div>
      <main className="card-content">
        <h1 className="card-header">{header}</h1>
        <p className="card-description">{description}</p>
      </main>
    </section>
  )
}

Card.propTypes = {
  description: PropTypes.string,
  rootClassName: PropTypes.string,
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  header: PropTypes.string,
}

export default Card
